class BaoAccordion extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  static get requiredElements () {
    return ['trigger', 'panel']
  }

  checkValidity () {
    super.checkValidity()

    if (this.disableOn) {
      if (!(this.disableOn in window.BAO.MediaBreakpoints.breakpoints)) {
        this.throwError(
          `The "disable-on" attribute must be one of the following values: ${Object.keys(
            window.BAO.MediaBreakpoints.breakpoints,
          ).join(', ')}`,
        )
      }
    }
  }

  connectedCallback () {
    super.connectedCallback()

    if (
      this.disableOn &&
      window.BAO.MediaBreakpoints[
        `is${window.BAO.Utils.capitaliseFirstLetter(this.disableOn)}`
      ]
    ) {
      this.els.trigger.element.setAttribute('aria-expanded', 'true')
      this.els.panel.element.hidden = false
      this.dataset.disabled = 'true'

      return
    }

    if (!this.els.trigger.element.hasAttribute('aria-expanded')) {
      this.els.trigger.element.setAttribute(
        'aria-expanded',
        window.BAO.MediaBreakpoints.isMd.toString(),
      )
    }

    this.panelWasHiddenOnLoad = this.els.panel.element.hidden

    this.els.panel.element.style.overflow = 'hidden'

    if (this.panelWasHiddenOnLoad) {
      this.els.panel.element.hidden = false
      this.els.panel.element.style.height = '0'
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.onTriggerClick.bind(this),
    )

    if (this.els.close?.exists) {
      this.listeners.add(
        this.els.close.element,
        'click',
        this.onCloseClick.bind(this),
      )
    }
  }

  onTriggerClick () {
    this.toggle(!this.open)
  }

  onCloseClick () {
    this.toggle(false)
  }

  /**
   * @param {boolean} open
   */
  toggle (open) {
    if (open === this.open) return

    this.els.trigger.element.setAttribute('aria-expanded', open.toString())

    if (open) {
      window.BAO.Utils.slideDown(this.els.panel.element, this.panelHeight)
    } else {
      window.BAO.Utils.slideUp(this.els.panel.element, this.panelHeight)
    }
  }

  /**
   * @returns {BaoMediaBreakpoint|undefined}
   */
  get disableOn () {
    return this.dataset.disableOn
  }

  get open () {
    return this.els.trigger.element.getAttribute('aria-expanded') === 'true'
  }

  get panelHeight () {
    this.els.panel.element.style.height = ''

    const height = this.els.panel.element.offsetHeight

    this.els.panel.element.style.height = '0'

    return height
  }
}

if (!customElements.get('bao-accordion')) {
  customElements.define('bao-accordion', BaoAccordion)
}
